import { IParameter, IParameterGroup } from '@/pages/Parameters/parameters.types.ts'
import eventBus from '@/services/eventBus'

const requestGroupCreate = (initialParentId: IParameterGroup['id'] = null) => {
  eventBus.pub('parameters.cud-service.request-group-create', { initialParentId })
}

const requestGroupUpdate = (groupId: IParameterGroup['id'] = null) => {
  eventBus.pub('parameters.cud-service.request-group-update', { groupId })
}

const requestParameterCreate = (initialGroupId: IParameterGroup['id'] = null) => {
  eventBus.pub('parameters.cud-service.request-parameter-create', { initialGroupId })
}

const requestParameterSidePage = (parameterId: IParameter['id']) => {
  eventBus.pub('parameters.cud-service.request-parameter-side-page', { parameterId })
}

const parametersCUDServiceEvents = {
  requestGroupCreate,
  requestGroupUpdate,
  requestParameterCreate,
  requestParameterSidePage,
}
export default parametersCUDServiceEvents
